import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as componentTypes from "../../../../constants/componentTypes";
import * as modelHelper from "../../../../helpers/modelHelper";
import * as navigationActions from "../../../../actions/navigationActions";
import * as translationHelper from "../../../../helpers/translationHelper";

import CustomIcon from "../../../global/CustomIcon";

import Modal from "../../../global/generic/Modal";
import CloseButton from "../../../global/generic/CloseButton";

class ImportPriceDataModal extends Component {
    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    getContent = () => {
        if (this.props.importing) {
            return <CustomIcon iconType={componentTypes.ICON_LOADER} className="loader-price-settings" alt="loading" />;
        }

        if (this.props.imported.length === 0) {
            return (
                <div>
                    <span className="general-label info-label">{translate("importData.imported")}</span>
                </div>
            );
        }

        return (
            <div className="height-100 flex flex-column">
                <span className="general-label warning-label">
                    {translationHelper.translateImportDataResultCode(this.props.errorCode)}
                </span>
                <div className="flex flex-column flex-align-start flex-child fill-flex-space slim-scroll">
                    {this.props.imported.map((msg, i) => (
                        <span key={i}>{msg}</span>
                    ))}
                </div>
            </div>
        );
    };

    render() {
        return (
            <Modal
                tabId={this.props.tabId}
                className="superior-modal"
                header={modelHelper.buildModalSection(<Translate value="importData.importPrices" />)}
                onClose={this.props.importing ? null : this.handleCloseModalClick}
                content={modelHelper.buildModalSection(this.getContent())}
                footer={
                    this.props.importing
                        ? null
                        : modelHelper.buildModalSection(<CloseButton onClick={this.handleCloseModalClick} />)
                }
                styles={{minWidth: "60%"}}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        importing: store.importData.importing,
        imported: store.importData.imported,
        errorCode: store.importData.errorCode
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.IMPORT_PRICE_DATA_MODAL));
        }
    };
};

export default ImportPriceDataModal = connect(mapStoreToProps, mapDispatchToProps)(ImportPriceDataModal);
